// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/breakpoint.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ouGuGTYlxbvdybm4uDzh {
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: auto;
  margin-bottom: 16px;
  margin-top: 30px;
  max-width: 1440px;
}

.dDFcsMJ07TX3ppMxD1OY {
  display: inline-block;
  width: 100%;
}

.ouGuGTYlxbvdybm4uDzh .Qtp8LFztayEmfPgqLIXK {
  white-space: pre-line;
}

.AQdz2v0LJvU9fPgF7DRM  {
  width: 40%;
  max-width: 720px;
}

.ouGuGTYlxbvdybm4uDzh .lb3y9CvUDkjOxfcoHQbF {
  width: 5%;
  height: 5px;
  float: left;
  display: block;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
  background-color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
  border-radius: 10px;
}

.ouGuGTYlxbvdybm4uDzh .bw9SU69iR9XuwkiBRAIA {
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text"]};
  font-weight: bold;
}

.bUt0eDx2BHzNdbNeXzVs {
  width: 40%;
  max-width: 720px;
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}) {
  .ouGuGTYlxbvdybm4uDzh {
    width: 100%;
    flex-direction: column;
  }
  
  .ouGuGTYlxbvdybm4uDzh .lb3y9CvUDkjOxfcoHQbF {
    width: 20%;
  }

  .AQdz2v0LJvU9fPgF7DRM {
    width: 100%;
  }

  .bUt0eDx2BHzNdbNeXzVs {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Eligible/Header/Header.module.css"],"names":[],"mappings":"AAMA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,WAAW;EACX,cAAc;EACd,8DAA8B;EAC9B,8DAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mDAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["@value breakpoints: \"components/library/style/breakpoint.css\";\n@value tablet-l from breakpoints;\n\n@value colors: \"components/library/style/colors.css\";\n@value color-text, color-purple from colors;\n\n.headerContainer {\n  width: 90%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: auto;\n  margin-bottom: 16px;\n  margin-top: 30px;\n  max-width: 1440px;\n}\n\n.fullWidth {\n  display: inline-block;\n  width: 100%;\n}\n\n.headerContainer .title {\n  white-space: pre-line;\n}\n\n.headerText  {\n  width: 40%;\n  max-width: 720px;\n}\n\n.headerContainer .hr {\n  width: 5%;\n  height: 5px;\n  float: left;\n  display: block;\n  border: 1px solid color-purple;\n  background-color: color-purple;\n  border-radius: 10px;\n}\n\n.headerContainer .subTitle {\n  color: color-text;\n  font-weight: bold;\n}\n\n.headerSlide {\n  width: 40%;\n  max-width: 720px;\n}\n\n@media screen and (max-width: tablet-l) {\n  .headerContainer {\n    width: 100%;\n    flex-direction: column;\n  }\n  \n  .headerContainer .hr {\n    width: 20%;\n  }\n\n  .headerText {\n    width: 100%;\n  }\n\n  .headerSlide {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}`,
	"colors": `"components/library/style/colors.css"`,
	"color-text": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text"]}`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]}`,
	"headerContainer": `ouGuGTYlxbvdybm4uDzh`,
	"fullWidth": `dDFcsMJ07TX3ppMxD1OY`,
	"title": `Qtp8LFztayEmfPgqLIXK`,
	"headerText": `AQdz2v0LJvU9fPgF7DRM`,
	"hr": `lb3y9CvUDkjOxfcoHQbF`,
	"subTitle": `bw9SU69iR9XuwkiBRAIA`,
	"headerSlide": `bUt0eDx2BHzNdbNeXzVs`
};
export default ___CSS_LOADER_EXPORT___;
